<template><div style="display: none" /></template>
<script>
import api from '../../proxy';
import { loginByUserToken } from '../../../../../lib/utils';
export default {
    name: 'TimeStatistics',
    props: {
        contentId: {
            type: [String, Number],
            default: '',
        },
    },
    computed: {
        loginStatus () {
            return this.$store.getters['global/isLogin'];
        },
        docmentHidden () {
            return this.$store.getters['system/getDocmentHidden'];
        },
    },
    watch: {
        docmentHidden (val) {
            if (!val) {
                this.timeInterval();
            } else {
                this.timeInterval('pause');
            }
        },
    },
    mounted () {
        this.requestStatistics(0);
        this.timeInterval();
    },
    beforeDestroy () {
        this.timeInterval('pause');
    },
    methods: {
        timeInterval (pause) {
            if (pause && this.loopTime) {
                clearInterval(this.loopTime);
                this.loopTime = null;
            } else {
                if (this.loopTime) return;
                this.loopTime = setInterval(() => {
                    if (!this.contentId) return;
                    this.requestStatistics(5);
                }, 5000);
            }
        },
        requestStatistics (time) {
            const param = {
                contentId: this.contentId,
                browseDuration: time,
            };
            if (this.loginStatus) {
                param.userId = this.$store.getters['global/loginInfo'].userId;
            }
            api.statisticsTime(param).then(res => {
                if (res.errcode === 4013) {
                    loginByUserToken(result => {
                        if (result) {
                            this.requestStatistics(time);
                        }
                    });
                }
            });
        },
    },
};
</script>
